import React from "react";
import "./events.css";
import Footer from "./Components/Footer/Footer";
import Navbar from "./Components/Navbar/Navbar";
import Reveal from "./Components/Reveal/Reveal";
import { images } from "./config/imagePaths";

const eventsList = [
  {
    title: "Conferences",
    text: "Ignite works with businesses to plan and deliver conferences that support strategic objectives, brand positioning and industry leadership. From concept development and speaker coordination to logistics and delivery, we manage the full process to ensure a professional, high-impact event that reflects your organisation and its goals.",
    image: images.events.conferences,
  },
  {
    title: "Team Days Out & Communications Days",
    text: "We design and manage team days and internal communications events that help businesses align teams, reinforce messaging and strengthen company culture. Whether the focus is strategy, engagement or change communication, Ignite ensures the day runs smoothly while delivering clear outcomes for the organisation.",
    image: images.events.teamDays,
  },
  {
    title: "Gala Dinners & Awards Nights",
    text: "Ignite produces gala dinners and awards nights that allow businesses to recognise achievement, strengthen relationships and enhance their brand reputation. We handle every detail, from venue sourcing and event flow to production and staging, delivering polished, memorable events that reflect your company's values.",
    image: images.events.galaDinners,
  },
  {
    title: "Trade Shows & Exhibitions",
    text: "We support businesses in planning and delivering trade shows and exhibitions that drive visibility, networking and commercial opportunity. Ignite manages event coordination, exhibitor logistics and overall execution, allowing organisations to focus on partnerships, promotion and growth while we take care of delivery.",
    image: images.events.tradeShows,
  },
];

export default function Events() {
  return (
    <div className="app-container">
      <Navbar />

      <main className="main-content events-main">
        <h1>Our Events</h1>

        <div className="events-list">
          {eventsList.map((event, index) => (
            <Reveal
              as="section"
              key={index}
              className={`event-block ${index % 2 !== 0 ? "event-block-reverse" : ""}`}
            >
              <div className="event-image-wrap">
                <img
                  src={event.image}
                  alt={event.title}
                  className="event-image"
                  decoding="async"
                />
              </div>
              <div className="event-text">
                <h2>{event.title}</h2>
                <p>{event.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
